<svg height="0" width="0">
  <defs>
    <clipPath id="clip_path_left" clipPathUnits="objectBoundingBox">
      <path
        d="M0,0 H0.963 C0.987,0,1,0.022,0.999,0.045 L0.857,0.593 C0.855,0.604,0.847,0.613,0.837,0.617 L0,1 V0"
        fill="white"
      />
    </clipPath>
  </defs>
</svg>

<svg height="0" width="0">
  <defs>
    <clipPath id="clip_path_right" clipPathUnits="objectBoundingBox">
      <path
        d="M1,0 H0.047 C0.02,0.002,0,0.024,0.006,0.048 L0.147,0.615 C0.15,0.625,0.157,0.634,0.168,0.64 L1,1 V0.069"
        fill="white"
      />
    </clipPath>
  </defs>
</svg>

@if (offerLink) {
  <lib-link [link]="offerLink" (onClick)="onOfferClick()">
    <ng-container *ngTemplateOutlet="offerBoxLight"></ng-container>
  </lib-link>
} @else {
  <ng-container *ngTemplateOutlet="offerBoxLight"></ng-container>
}

<ng-template #offerBoxLight>
  <div class="offer-box-light-wrapper h-full" [ngClass]="{ 'md:mt-20': styleSide === 'right' }">
    @if (offer?.slices && offer?.slices?.length > 0) {
      <div>
        @for (slice of offer.slices; track slice) {
          @if (slice.type === 'promo_banner') {
            <lib-offer-sticker
              [width]="'md:w-11/12 w-10/12'"
              [margin]="styleSide === 'right' ? 'ml-auto' : ''"
              [borderRadius]="styleSide === 'right' ? 'promo-banner-left-rounded' : 'promo-banner-right-rounded'"
              [fontSize]="'offer-box-light-font-size'"
              [slice]="$any(slice)"
            >
            </lib-offer-sticker>
          }
        }
      </div>
    }
    <div
      class="relative flex flex-col bg-white pt-5 text-color-product-box-description offer-box-light"
      [ngClass]="{ 'offer-box-light-left': styleSide === 'left', 'offer-box-light-right': styleSide === 'right' }"
    >
      @if (offer?.useCustomContent || offer?.useCustomContent === null) {
        <ngx-dynamic-hooks
          data-source="prismic"
          [content]="offer?.content"
          [options]="{ sanitize: false }"
          class="flex flex-col"
          [ngClass]="{ 'w-11/12': styleSide === 'left', 'float-right text-right pl-14': styleSide === 'right' }"
        >
        </ngx-dynamic-hooks>
      } @else {
        <div [class]="containerCssClass">
          <div data-source="prismic" [innerHtml]="offer.title" [class]="titleCssClass"></div>
          @if (offer.checkMarks) {
            <div
              [ngClass]="{
                'ml-auto pl-14': offer.contentAlignment === 'right',
                'pr-12': offer.contentAlignment === 'left',
              }"
            >
              @for (checkMark of offer.checkMarks; track checkMark) {
                <div class="flex mb-2 items-center">
                  <img style="width: 1.5rem" src="check-mark-yallo" />
                  <div class="check" data-source="prismic" [innerHtml]="checkMark"></div>
                </div>
              }
            </div>
          }
          <div class="mb-2" data-source="prismic">
            @if (offer.pricePrefix) {
              <span [class]="priceFontSize">{{ offer.pricePrefix }}</span>
            }
            @if (!offer.promoPrice) {
              <span [class]="priceFontSize">
                {{ offer.normalPrice }}
              </span>
            } @else {
              <span [class]="priceFontSize">
                <span class="text-red"> {{ offer.promoPrice }}</span>
                <small>
                  <span class="crossed-out"> {{ offer.normalPrice }}</span></small
                >
              </span>
            }
            <ng-template #promoPrice>
              <span [class]="priceFontSize">
                <span class="text-red"> {{ offer.promoPrice }}</span>
                <small>
                  <span class="crossed-out"> {{ offer.normalPrice }}</span></small
                >
              </span>
            </ng-template>
          </div>
          <div data-source="prismic" [innerHtml]="offer.textAfterPrice"></div>
        </div>
      }
      @if (offer?.slices && offer?.slices?.length > 0) {
        <div class="flex flex-col mt-3">
          @for (slice of offer.slices; track slice) {
            @if (slice.type === 'count_down') {
              <div class="mt-2">
                <lib-countdown
                  [countdownDateFromPrismic]="$any(slice).countdownDate"
                  [isOfferBoxLight]="true"
                  [ngClass]="{ 'float-right': styleSide === 'right' }"
                >
                </lib-countdown>
              </div>
            }
            @if (slice.type === 'offer_cta') {
              <div>
                <lib-offer-box-button [slice]="$any(slice)" [isHeroOffer]="isHeroOffer" [offerBoxSide]="styleSide">
                </lib-offer-box-button>
              </div>
            }
          }
        </div>
      }
    </div>
  </div>
</ng-template>
